import React from 'react';
const IconMiscWorldFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.0498 12.97C2.4398 16.97 5.1898 20.28 8.8898 21.5L5.7898 12.98L2.0498 12.97Z" fill="#2D2E2E"/>
<path d="M7.91992 12.98L11.1899 21.96C11.8599 22.01 12.1299 22.02 12.8099 21.96L16.0699 12.99L7.91992 12.98Z" fill="#2D2E2E"/>
<path d="M15.1099 21.5C18.7999 20.29 21.5599 16.99 21.9499 13H18.1999L15.1099 21.5Z" fill="#2D2E2E"/>
<path d="M21.9499 11C21.5499 7.01 18.7999 3.71 15.1099 2.5L18.1999 11H21.9499Z" fill="#2D2E2E"/>
<path d="M16.0699 10.99L12.8099 2.03999C12.1399 1.98999 11.8699 1.97999 11.1899 2.03999L7.93994 10.98L16.0699 10.99Z" fill="#2D2E2E"/>
<path d="M8.8898 2.5C5.2098 3.71 2.4598 7 2.0498 10.97H5.7998L8.8898 2.5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscWorldFill;